import { Result, Image } from 'antd';
import { useTranslation } from 'react-i18next';
import usePublic from '../../utilities/usePublic';

type LeadGenFormUnavailableResultProps = {
    eventName?: string;
};

const LeadGenFormUnavailableResult = ({ eventName = 'Event' }: LeadGenFormUnavailableResultProps) => {
    const { t } = useTranslation(['common']);

    const src = usePublic('expiredPage.png');

    return (
        <Result
            icon={<Image preview={false} src={src} style={{ width: '50%' }} />}
            subTitle={t('common:errors:leadGenFormUnavailable:description')}
            title={t('common:errors:leadGenFormUnavailable:title', { eventName })}
        />
    );
};

export default LeadGenFormUnavailableResult;
